import React, { useEffect, useState } from "react";
import { Card } from "shards-react";
import "./loader/loading.css";
import "./documentation-start.css";
import Markdown from "markdown-to-jsx";
import Storage from "../../services/storage-service/Storage";
import DocumentationService from "../../services/documentation-service/DocumentationService";
import CustomizedCardHeader from "../../components/customized-card-header/CustomizedCardHeader";

const Documentation = () => {
    const [markdownFile, setMarkdownFile] = useState(null);

    useEffect(() => {
        getDocumentation();
    }, []);

    async function getDocumentation() {
        const userDocNameStorage = Storage.get(
            Storage.KEYS.USER_DOCUMENTATION_NAME
        );
        const documentation = await DocumentationService.getDocumentation(
            userDocNameStorage
        )
            .then(res => res)
            .catch(() => null);

        if (documentation) {
            setMarkdownFile(documentation);
        }
    }

    return (
        <React.Fragment>
            <Card className="ag-theme-material cardStyle">
                <CustomizedCardHeader
                    className={"border-bottom"}
                    initialName={"Documentação"}
                />
                <div className="contentStyle" id="contentStyleMarkdown">
                    {markdownFile && <Markdown>{markdownFile}</Markdown>}
                </div>
            </Card>
        </React.Fragment>
    );
};

export default Documentation;
